import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const GetAllContactUsersQuery = gql`
  query GetAllContactUsers{
    all_users(exclude_no_contact_info: true, exclude_terminated: true) {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  /* NOTE: must use userScope as var. UserPicker is expecting it. */
  const userScope = querySelector(data, '$.all_users.edges[*].node', []);
  return {
    data,
    ...ownProps,
    userScope,
  };
};

const GetAllContactUsersQueryData = graphql(GetAllContactUsersQuery, { props: marshallData });

export const queryGetAllContactUsersGQL = compose(
  GetAllContactUsersQueryData,
  queryMetaHandler,
  omitProps(['data']),
);
